/*
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2021-12-10 19:38:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2023-07-14 16:40:50
 * @FilePath: /WeMeet_admin_project/wemeet-admin/src/utils/pageTitle.js
 * @Description:
 * Copyright (c) 2023 by WeMeet, All Rights Reserved.
 */
import { titleReverse, titleSeparator } from '@/config'
import store from '@/store'
import i18n from '@/i18n'

/**
 * @description 设置标题
 * @param pageTitle
 * @returns {string}
 */
export default function getPageTitle(pageTitle) {
  // const title = store.getters['settings/title']
  let customInfo = localStorage.getItem('customInfo')
  customInfo = JSON.parse(customInfo)
  let title = ''
  if (customInfo.customTitle) {
    title = customInfo.customTitle
  } else {
    title = store.getters['settings/title']
  }
  const { t, te } = i18n.global
  if (te(`vabI18n.${pageTitle}`)) pageTitle = t(`vabI18n.${pageTitle}`)
  let newTitles = []
  if (pageTitle) newTitles.push(pageTitle)
  if (title) newTitles.push(title)
  if (titleReverse) newTitles = newTitles.reverse()
  return newTitles.join(titleSeparator)
}
